/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import React, {
    forwardRef,
    memo,
    useCallback,
    useEffect,
    useState,
} from 'react'
import RightSidebar from './RightSidebar.tsx'
import Scrub from './Scrub.tsx'
import type Swing from './types/Swing'

const PREFIX = 'splendid-splinter'

type VideoProps = {
    handleChange: () => void
    isScrubbing: boolean
    setIsScrubbing: (isScrubbing: boolean) => void
    selected?: Swing
}

// TODO: VERIFY THESE WITH FINAL SPEED DECISIONS
const MAGIC_ATTACK_ANGLE_TIME = 10
const MAGIC_ATTACK_DIRECTION_TIME = 12.3
const MAGIC_SWING_PATH_TILT_TIME = 16.88

const Video = memo(
    forwardRef<HTMLVideoElement, VideoProps>(
        ({ handleChange, isScrubbing, selected, setIsScrubbing }, ref) => {
            const [isError, setIsError] = useState(false)

            useEffect(() => {
                // Could be a function says TS
                if (!ref || !('current' in ref)) {
                    return
                }

                const video = ref.current

                if (!video) {
                    return
                }

                setIsError(false)

                video.load()

                handleChange()

                // if (isAutoPlay) {
                //     video.load();
                //     video.currentTime = 0;
                //     const playPromise = video.play();

                //     if (playPromise !== undefined) {
                //         // We expect this to fail first time
                //         playPromise.catch((e) => {
                //             console.log(
                //                 "playback failed, because of reasonable browser reasons",
                //                 video.duration
                //             );
                //         });
                //     }
                // } else {
                //     const time = video.currentTime;

                //     video.load();
                //     maxTime.current = video.duration;

                //     video.currentTime = time;
                // }
            }, [selected])

            const handleSidebarClick = useCallback(
                (section: string) => {
                    // Could be a function says TS
                    if (!ref || !('current' in ref)) {
                        return
                    }

                    const video = ref.current

                    if (!video) {
                        return
                    }

                    setIsScrubbing(false)

                    switch (section) {
                        case 'attack-angle':
                            video.currentTime = MAGIC_ATTACK_ANGLE_TIME
                            break
                        case 'attack-direction':
                            video.currentTime = MAGIC_ATTACK_DIRECTION_TIME
                            break
                        case 'swing-path-tilt':
                            video.currentTime = MAGIC_SWING_PATH_TILT_TIME
                            break
                        default:
                    }

                    video.pause()
                },
                [setIsScrubbing]
            )

            let url = ''
            let posterUrl = ''
            if (selected) {
                const { playerId, year, batSide } = selected
                url = `https://builds.mlbstatic.com/baseballsavant.mlb.com/swing-path/${PREFIX}/cut/${playerId}-${year}-${batSide}.mp4`
                posterUrl = `https://builds.mlbstatic.com/baseballsavant.mlb.com/swing-path/${PREFIX}/posterized/${playerId}-${year}-${batSide}.png`
            }

            const video =
                ref && 'current' in ref && ref.current ? ref.current : null

            return (
                <div>
                    <div style={{ position: 'relative', display: 'block' }}>
                        <video
                            ref={ref}
                            id="viz-video"
                            onError={() => setIsError(true)}
                            preload="auto"
                            muted
                            playsInline
                            poster={posterUrl}
                        >
                            {selected && <source src={url} type="video/mp4" />}
                        </video>
                        {isError && (
                            <div
                                style={{
                                    display: 'flex',
                                    backgroundColor: 'rgb(4, 30, 66)',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    color: 'white',
                                    fontSize: '24px',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0,
                                }}
                            >
                                Error Loading Swing
                            </div>
                        )}
                        {!selected && (
                            <div
                                style={{
                                    display: 'flex',
                                    backgroundColor: 'rgb(4, 30, 66)',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    color: 'white',
                                    fontSize: '24px',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0,
                                }}
                            >
                                Use the button below to add a player
                            </div>
                        )}
                        {!isError && selected && (
                            <>
                                <RightSidebar onClick={handleSidebarClick} />
                                {/* Not entirely sure why this check is necessary, but it is! */}
                                {isScrubbing && video && (
                                    <Scrub $video={video} />
                                )}
                            </>
                        )}
                    </div>
                </div>
            )
        }
    )
)

Video.displayName = 'Video'

export default Video
